import React, {FunctionComponent, useEffect, useState} from "react";

import Styles from "./Service_list.module.scss";
import {useNavigate, useParams} from 'react-router-dom';

//import Select from 'react-select'

import Button from '@mui/material/Button';

// import EastIcon from '@mui/icons-material/East';

import {IUserInfo} from "../../models/user";
import IMG_BTN_PAUSE from '../../images/ui/service_btn_pause.png'
import IMG_BTN_PLAY from '../../images/ui/service_btn_play.png'
import IMG_BTN_STATS from '../../images/ui/service_btn_stats.png'
import IMG_BTN_SHARE from '../../images/ui/service_btn_share.png'
import IMG_BTN_CONFIG from '../../images/ui/service_btn_config.png'



import Auth from "../../services/auth";

import {Utils} from "../../helpers/utils";
import CONFIG from "../../config";
import {AlertColor, IconButton, Paper, styled} from "@mui/material";
import {API} from "../../services/API";
import Grid from "@mui/material/Unstable_Grid2";
import {IService} from "../../interfaces/interfaces";
import {type} from "os";
import {FooterLinks_MainMenu} from "../footer/FooterLinks_MainMenu";

const utils = new Utils();

interface Props {
    userAuth: boolean;
    setUserAuth:  React.Dispatch<React.SetStateAction<boolean>>;
    userInfo: IUserInfo;
    setUserInfo:  React.Dispatch<React.SetStateAction<IUserInfo>>;
    footer: React.ReactNode;
    setFooter: React.Dispatch<React.SetStateAction<React.ReactNode>>;
    setGlobalMessage:  React.Dispatch<React.SetStateAction<{type: AlertColor, message: String}>>;
    setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

interface itemData { key: string; row: IService; }

export const Service_List = ({userAuth, setUserAuth, userInfo, setUserInfo, footer, setFooter, setGlobalMessage, setIsLoading} : Props) => {
    const navigate = useNavigate();
    const [userServices, setUserServices] = useState<IService[]>([])
    //const [inputDomain, setInputDomain] = useState<string>("")

    const handleBack = ( ) => {
        //navigate(-1)
    };
    const handleNext = async () => {
        //setGlobalMessage({type: "success", message: "Успішна реєстрація"} )
        //Auth.DoLogout({setUserAuth, userInfo, setUserInfo});
        // let req_res = await API.service_checkName(inputDomain)
    }

    useEffect(  () => {
        const fetchData = async () => {
            //console.log(userInfo)


            let token = `${userInfo.authToken};;${userInfo.authDate}`;
            let data  = await API.service_list(token);

            if (data.message.error > 0) {
                if (data.message.error == 401) {
                    // TODO :remove comment
                    Auth.DoLogout({setUserAuth, userInfo, setUserInfo});

                }
                setGlobalMessage({type: "error", message:data.message.message} )

            } else {
                setUserServices( data.message.data )
                //console.log( data.message )
            }
            setIsLoading(false);

        }
        setIsLoading(true);
        //setFooter(FooterLinks_MainMenu(["home", "bookings", "profile", "clients"]))
        //setTimeout(()=>setFooter(FooterLinks_MainMenu(["home", "bookings", "profile", "clients"])), 100)
        fetchData();
    }, [])




    const getServiceType = ( service_type : string) => {
        for (var st of CONFIG.SERVICE_TYPES) {
            if (st.value == service_type)    return st
        }
        return {label: "", value : ""};
    }




    const Item = ( { row } : itemData ) => {
        //console.log(row)

        //row.service_type
        //row.url_name
        //row._id

        let name = row.url_name || "";
        if (name.length > 15) name = name.slice(0, 14) + '..';

        let service_type_obj = getServiceType(row.service_type || "")

        let address = row.address || "Адресу не вказано"

        return  (
            <Grid className={Styles.gridRow} xs={12} container spacing={1}>
                <Grid xs={6} spacing={0}>
                    <div>
                        <div className={Styles.title_type}>{service_type_obj.label}</div>
                        <div className={Styles.title_name}><a href={`/s/${name}`}>{name}</a> </div>
                        <div className={Styles.title_address}>{address}</div>
                    </div>
                </Grid>
                <Grid xs={6} className={Styles.buttons_grp}>
                    <IconButton onClick={handleBack}  color="secondary" aria-label="Зупинити" size="small">
                        <img src={IMG_BTN_PAUSE || IMG_BTN_PLAY} alt="Зупинити" title="Зупинити" />
                    </IconButton>
                    <IconButton onClick={()=>navigate(`/bookingsService/${row._id}`)}  color="secondary" aria-label="Статистика" size="small">
                        <img src={IMG_BTN_STATS} alt="Статистика" title="Статистика" />
                    </IconButton>
                    <IconButton onClick={()=>navigate(`/services/share/${row._id}`)}  color="secondary" aria-label="Інфо для клієнтів" size="small">
                        <img src={IMG_BTN_SHARE} alt="Інфо для клієнтів" title="Інфо для клієнтів" />
                    </IconButton>
                    <IconButton onClick={()=>navigate(`/services/edit/${row._id}`)}  color="secondary" aria-label="Конфігурація" size="small">
                        <img src={IMG_BTN_CONFIG} alt="Конфігурація" title="Конфігурація" />
                    </IconButton>


                </Grid>
            </Grid>
        )
    }

    return (
        <div>
            <center><h1>Мої послуги</h1></center>
            <Grid container spacing={1}>
                {
                    userServices.map((row) => (
                        <Item key={(row.url_name || "" ).toString()} row={row}/>


                    ))
                }

            </Grid>
        </div>
    );
}